import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import CharMap from './charMap';
import enCharMap from './enCharMap';

/**
 * @description: decode the char in JOSN value
 * @param {Object} json
 */
export function decodeChar(json) {
  if (!(json instanceof Object)) return;
  for (var key in json) {
    if (!(json[key] instanceof Object)) {
      if (typeof json[key] === 'string') {
        // json[key] = replaceAll(json[key])
        json[key] = unescape(json[key].replace(/\\u/g, '%u'));
      }
    } else {
      decodeChar(json[key]);
    }
  }
}
export function replaceAll(source) {
  var target = source;
  var key = '';
  while (Object.keys(CharMap).some(function (v) {
    key = v;
    return target.includes(v);
  })) {
    target = target.replace(key, CharMap[key]);
  }
  return target;
}
export function encodeChar(json) {
  if (!(json instanceof Object)) return;
  for (var key in json) {
    if (!(json[key] instanceof Object)) {
      if (typeof json[key] === 'string') {
        json[key] = replaceChar(json[key]);
      }
    } else {
      encodeChar(json[key]);
    }
  }
}
export function replaceChar() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var target = source;
  var key = '';
  // 对于0X先进行转义
  if (target.includes('0X')) {
    target = target.replace(/0X/g, "\\u0030\\u0058");
  }
  if (target.includes('0x')) {
    target = target.replace(/0x/g, "\\u0030\\u0078");
  }
  while (Object.keys(enCharMap).some(function (v) {
    key = v;
    return target.includes(v);
  })) {
    target = target.replace(key, enCharMap[key]);
  }
  return target;
}
// url参数添加encodeYRL
export function funcUrlDel(url) {
  var temp1 = url.split('?');
  var pram = temp1[1] || '';
  var newparams = [];
  if (pram) {
    var keyValue = pram.split('&');
    newparams = keyValue.map(function (i) {
      var item = i.split('=');
      var key = item[0];
      var value = replaceChar(item[1]);
      return key + '=' + value;
    }).join('&');
    return temp1[0] + '?' + encodeURI(newparams);
  }
  return url;
}

// 字符串进行encode转码
export function encodeUnicode(str) {
  if (!str) return '';
  var res = [];
  for (var i = 0; i < str.length; i++) {
    res[i] = ('00' + str.charCodeAt(i).toString(16)).slice(-4);
  }
  return "\\u" + res.join("\\u");
}